import percent from '@pkg/utils/numbers/percent';
import applyMetrics from './metrics';
import normalize from './normalize';

export default function deriveGroup({
  activity,
  deriveMetrics,
  groupId,
  groupSet,
  metrics,
  role,
  roleSet,
  library,
  snapshot,
}) {
  if (!groupId) {
    return;
  }

  const isNewGroup = !groupSet || groupSet.has(groupId);

  const group = isNewGroup
    ? normalize({
        group: snapshot.entities.groups[groupId],
        library,
        snapshot,
      })
    : snapshot.entities.groups[groupId];

  // In cases where the group isn't included in the current snapshot level.
  if (!group) {
    return;
  }

  if (deriveMetrics) {
    group.__metrics.self = applyMetrics({
      activity,
      role,
      roleSet,
      group,
      groupSet,
      metrics,
    });

    group.__percentage = percent(
      group.__metrics.self.visible.hours,
      group.__metrics.self.total.hours
    );
    group.__total_metrics = { ...group.__metrics.self.total };
    group.__visible_metrics = { ...group.__metrics.self.visible };

    metrics.set(group.uuid, { ...group.__metrics });
  }

  return group;
}
